import { render, staticRenderFns } from "./McKing.vue?vue&type=template&id=5416435d&scoped=true&"
import script from "./McKing.vue?vue&type=script&lang=js&"
export * from "./McKing.vue?vue&type=script&lang=js&"
import style0 from "./McKing.vue?vue&type=style&index=0&id=5416435d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416435d",
  null
  
)

export default component.exports